import { nextTick, watch } from "vue";
import model from "../model";
import { redeemLangObj } from "../utils/utils";

export default {
    init(){
        if(!model.clientConfig.zendesk?.active) return;

        window.zESettings = {
            webWidget: {
                position: { horizontal: 'right', vertical: 'bottom' },
                offset: {
                    mobile: {
                        vertical: '100px',
                    },
                },
                chat: {
                    title: {
                        '*': '24/7 Live Chat',
                        es: '24/7 Chat en Vivo',
                    },
                    concierge: {
                        title: {
                            '*': 'Ask us anything!',
                            es: '¡Pregúntanos lo que quieras!',
                        },
                    },
                }
            },
        };

        let organization: string | null | undefined = null;

        if(model.isApp){
            window.initZendesk = () => {
                init.call(this);
                delete window.initZendesk;
            }
        }
        else{
            const unwatch = watch(() => model.cookiesAccepted, async value => {
                if(!value) return;
                await nextTick();
                unwatch();
                const int = setInterval(() => {
                    if(document.readyState !== 'complete') return;
                    clearInterval(int);
                    init.call(this);
                }, 1000);
            }, {immediate: true});
        }

        function init() {
            let scriptElem: string | null | undefined | ChildNode | HTMLScriptElement = redeemLangObj(model.clientConfig.zendesk?.scriptElem || {});
            if(scriptElem){
                let temp = document.createElement('div');
                temp.innerHTML = scriptElem;
                scriptElem = temp.firstChild as HTMLScriptElement;
                if(scriptElem && 'id' in scriptElem && 'src' in scriptElem){
                    let script = document.createElement('script');
                    script.id = scriptElem.id;
                    script.src = scriptElem.src;
    
                    document.body.appendChild(script);
                }
            }

            var titleElements = window.document.head.getElementsByTagName('title');
            organization = titleElements.length > 0 ? titleElements?.[0]?.text : '';

            model.on('LoginComplete', () => {
                if (!window.zE?.identify) return;
                identifyAsAuth();
            });

            let int = setInterval(() => {
                const zendeskConfig = model.clientConfig.zendesk;
                if(!zendeskConfig || !window.zE) return;

                clearInterval(int);

                zE(() => {
                    zE.setLocale(model.lang);
                    if (model.uToken && model.userProfile) identifyAsAuth();
    
                    $zopim(() => {
                        setLang();
    
                        $zopim.livechat.badge.hide();

                        if(model.isMobile){
                            $zopim.livechat.window.onHide(() => {
                                zE('webWidget', 'hide');
                            });
                        }
    
                        if (zendeskConfig.theme) {
                            if (zendeskConfig.theme.color)
                                $zopim.livechat.theme.setColor(zendeskConfig.theme.color);
                        }
    
                        if (zendeskConfig.concierge && zendeskConfig.concierge.avatar)
                            $zopim.livechat.concierge.setAvatar(zendeskConfig.concierge.avatar);
    
                        $zopim.livechat.theme.reload();
    
                        triggerWidgetDisplay();
    
                        if (model.isMobile) {
                            watch(() => model.activeModal, triggerWidgetDisplay);
                            watch(() => model.notifications.length, triggerWidgetDisplay);
                        }
                        else watch(() => model.isMobile, () => triggerWidgetDisplay());
                        
                        watch(() => model.view, triggerWidgetDisplay);
                        watch(() => model.subnavView, triggerWidgetDisplay);
                        
                        model.dispatch('ZendeskLoaded');
                    });
                });
            }, 100);

            watch(() => model.lang, setLang);

            function triggerWidgetDisplay() {
                if(model.isMobile) zE('webWidget', 'hide');
                else{
                    zE('webWidget', (
                        model.activeModal ||
                        model.notifications.length ||
                        model.isMobile
                    ) ? 'hide' : 'show');
                }
            }
        }

        function identifyAsAuth() {
            model.userProfile && zE?.identify({
                name: model.userProfile.firstName + ' ' + model.userProfile.lastName,
                email: model.userProfile.email,
                organization: organization,
            });
        }

        function setLang() {
            var newLang = model.lang;
            window?.zE?.setLocale?.(newLang);
            window.$zopim?.livechat.setLanguage(newLang);

            window.$zopim?.livechat?.concierge.setName(redeemLangObj({
                en: 'Customer Support',
                es: 'Atención al Cliente',
            }) || '');
        }
    },
}